@if (vm$(); as viewModel) {
  <div class="lg:mt-16 max-w-[400px] mx-auto p-8 bg-card rounded-lg">
    @if (!viewModel.done) {
      <div
        class="text-l font-semibold"
        [ngClass]="viewModel.brand.isToyota() ? 'text-toyotaRed' : 'text-lexusBlue'"
      >
        Zugangslink anfordern
      </div>

      <p class="mt-8 max-w-xs leading-5 tracking-wide text-lightText">
        @if (viewModel.brand.isToyota()) {
          <span>Aus technischen Gründen ist es uns leider nicht möglich, Ihnen direkt Zugriff auf das Toyota Einwilligungscenter zu geben.</span>
        } @else {
          <span>Aus technischen Gründen ist es uns leider nicht möglich, Ihnen direkt Zugriff auf das Lexus Einwilligungscenter zu geben.</span>
        }
        <span>Bitte nennen Sie uns Ihre E-Mail-Adresse, damit wir Ihnen Ihren persönlichen Zugangslink zuschicken können. Wir bitten um Entschuldigung für die Umstände.</span>
      </p>
    } @else {
      <p class="max-w-xs font-semibold leading-5 tracking-wide  text-success">
        <span>Wenn uns Ihre E-Mail-Adresse bekannt ist, senden wir Ihnen nun Ihren individuellen Zugangslink zu</span>
        <span></span>
      </p>
    }

    @if (!viewModel.done) {
      <div class="flex flex-col mt-5 space-y-5 md:flex-row md:space-x-5 md:space-y-0">
        <input
          #textfield
          class="p-2 text-lightText placeholder:text-xs border border-gray-100 rounded-lg placeholder:md:text-left focus:outline-none"
          id="textfield"
          placeholder="E-Mail"
          type="email"
          (input)="setEmail(textfield.value)"
        >
        <button
          #button
          class="disabled:bg-gray-400 px-5 py-3 text-xs rounded-md bg-toyotaRed enabled:hover:scale-105 font-semibold text-white duration:500"
          [disabled]="viewModel.isLookupDisabled"
          id="button"
          (click)="didClickLookupButton()"
        >
          @if (viewModel.inProgress) {
            <app-activity-spinner />
          }
          Senden
        </button>
      </div>
    }
  </div>
}
